import { Component, input, output, computed, inject } from '@angular/core';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { I18nService } from '../../services/i18n.service';
import { UiService } from '../../services/ui.service';
import { NavButtonComponent } from '../nav-button/nav-button';

@Component({
  selector: 'app-exit-creation-popup',
  imports: [NzModalModule, NavButtonComponent],
  templateUrl: './exit-creation-popup.html',
  styleUrls: ['./exit-creation-popup.scss'],
})
export class ExitCreationPopupComponent {
  exitBuildingAreaSetup = input<boolean>(false);
  closeEvent = output<boolean>();
  public i18n = inject(I18nService);
  private ui = inject(UiService);

  readonly isMobile = computed(() => this.ui.IsMobile());

  onClosePopup(value: boolean) {
    this.closeEvent.emit(value);
  }
}
